

let cachedScrollbarWidth: number | null = null;

/**
 * Calculates the width of the browser's scrollbar.
 * This value is cached after the first calculation for performance.
 * @returns The scrollbar width in pixels
 */
export function getScrollbarWidth(): number {
  // Return cached value if already calculated
  if (cachedScrollbarWidth !== null) {
    return cachedScrollbarWidth;
  }

  // Create a temporary element to measure scrollbar width
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculate the difference between the outer and inner widths
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Clean up
  outer.parentNode?.removeChild(outer);

  // Cache the result
  cachedScrollbarWidth = scrollbarWidth;

  return scrollbarWidth;
}

